<div class="card bg-dark-lighter text-white wallet-transaction">
  <div
    class="card-header"
    data-bs-toggle="collapse"
    attr.data-bs-target="#{{ type }}Transaction"
    aria-expanded="false"
    attr.aria-controls="{{ type }}Transaction"
    (click)="onTriggerData(type)"
  >
    <span>{{ getTitle() + " Transaction" | uppercase }}</span>
    <a
      class="btn-collapse collapsed ml-15"
      data-bs-toggle="collapse"
      attr.data-bs-target="#{{ type }}Transaction"
      aria-expanded="false"
      attr.aria-controls="{{ type }}Transaction"
    >
      <i class="fa fa-compress"></i>
      <i class="fa fa-expand"></i>
    </a>
    <fx-export-button
      classes="pull-right text-red"
      icon="fa fa-print"
      text="Export"
      [tableId]="'tbl' + type + 'Transaction'"
      fileName="{{ type }}_transaction"
      [excludeImage]="true"
    ></fx-export-button>
  </div>
  <div class="card-body no-padder collapse" id="{{ type }}Transaction">
    <div class="p-3">
      <div class="row mb-15">
        <div class="col-md-6">
          <div
            class="input-group search-group"
            [ngClass]="{ loading: loading }"
          >
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              placeholder="Search transaction"
              [(ngModel)]="condition.keyword"
              (keyup)="onKeyup($event)"
            />
            <button
              class="btn btn-main"
              type="button"
              (click)="searchTransaction(true)"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table
              class="rox-table table-bordered bg-dark"
              id="tbl{{ type }}Transaction"
            >
              <thead>
                <tr>
                  <th>ID</th>
                  <th>MT5 Account</th>
                  <th class="text-center">Time</th>
                  <th class="text-center">
                    Asset
                    <select
                      *ngIf="type !== 'perfect-money'"
                      class="fx-select bg-dark-lighter text-white"
                      name="ddlAsset"
                      [(ngModel)]="condition.asset"
                      (change)="searchTransaction()"
                    >
                      <option value="">All</option>
                      <option
                        *ngFor="
                          let item of type == 'bitgo'
                            ? walletCoins
                            : walletOther
                        "
                        value="{{ item.id }}"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </th>
                  <th class="text-center">Transaction ID</th>
                  <th class="text-center">
                    Type
                    <select
                      class="fx-select bg-dark-lighter text-white"
                      name="ddlType"
                      [(ngModel)]="condition.type"
                      (change)="searchTransaction()"
                    >
                      <option value="">All</option>
                      <option value="0">Deposit</option>
                      <option value="1">Withdraw</option>
                    </select>
                  </th>
                  <th class="text-center" *ngIf="type == 'bitgo'">Rate</th>
                  <th class="text-end">Nominal Volume</th>
                  <th class="text-center">Fee</th>
                  <th class="text-end">Actual Volume</th>
                  <th class="text-center">Email</th>
                  <th class="text-center">
                    Status
                    <select
                      class="fx-select bg-dark-lighter text-white"
                      name="ddlType"
                      [(ngModel)]="condition.status"
                      (change)="searchTransaction()"
                    >
                      <option value="">All</option>
                      <option value="{{ opt.id }}" *ngFor="let opt of status">
                        {{ opt.name }}
                      </option>
                    </select>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let t of data
                      | paginate
                        : {
                            id: type,
                            itemsPerPage: pageInfo.pageSize,
                            currentPage: pageInfo.pageIndex,
                            totalItems: pageInfo.totalRecord
                          };
                    let i = index
                  "
                >
                  <td>{{ t.id }}</td>
                  <td class="text-center">{{ t.login }}</td>
                  <td class="text-center">
                    {{ t.time | date: "MM/dd/yyyy HH:mm:ss" }}
                  </td>
                  <td class="text-center text-{{ t.asset }}">
                    {{ t.asset | uppercase }}
                    <!--<div class="d-flex">
                    <fx-symbol-icon
                      class="d-none d-lg-block d-xl-block"
                      [first]="t.asset | lowercase "
                    &gt;</fx-symbol-icon>
                  </div>-->
                  </td>
                  <td class="text-center">{{ t.refId }}</td>
                  <td class="text-center">
                    <span
                      class="{{ t.type === 1 ? 'text-red' : 'text-green' }}"
                      >{{ t.getType() }}</span
                    >
                  </td>
                  <td class="text-center" *ngIf="type == 'bitgo'">
                    <ng-container *ngIf="t.type === 1 && t.status === 0">
                      <span
                        labelNumber="{{ t.rate }}"
                        [currency]="'usd'"
                      ></span>
                    </ng-container>
                  </td>
                  <td class="text-end">
                    <span
                      *ngIf="t.nominalVolume != undefined"
                      class="{{ t.type === 1 ? 'text-red' : 'text-green' }}"
                      >{{ t.type === 1 ? "-" : "+" }}
                      <span
                        labelNumber="{{ t.nominalVolume }}"
                        [currency]="t.nominalAsset"
                      ></span>
                      {{ t.nominalAsset | uppercase }}
                    </span>
                  </td>
                  <td class="text-end">
                    <span *ngIf="t.fee != undefined">
                      <span
                        labelNumber="{{ t.fee }}"
                        [currency]="t.feeAsset"
                      ></span>
                      {{ t.feeAsset | uppercase }}
                    </span>
                  </td>
                  <td class="text-end">
                    <span *ngIf="t.actualVolume != undefined">
                      <span
                        labelNumber="{{ t.actualVolume }}"
                        [currency]="t.actualAsset"
                      ></span>
                      {{ t.actualAsset | uppercase }}
                    </span>
                  </td>
                  <td class="text-center">{{ t.email }}</td>
                  <td class="text-center">
                    <ng-container
                      *ngIf="
                        t.status == 0 &&
                        type != 'banking' &&
                        permission.allowUpdating
                      "
                    >
                      <button
                        class="btn btn-primary m-2"
                        (click)="approve(t, 2)"
                      >
                        Approve
                      </button>
                      <button class="btn btn-main m-2" (click)="approve(t, 4)">
                        Reject
                      </button>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        t.status == 101 &&
                        type == 'banking' &&
                        permission.allowUpdating
                      "
                    >
                      <button
                        class="btn btn-primary m-2"
                        (click)="approve(t, 2)"
                      >
                        Approve
                      </button>
                      <button class="btn btn-main m-2" (click)="approve(t, 4)">
                        Reject
                      </button>
                    </ng-container>
                    <ng-container *ngIf="t.status != 0">
                      <div [innerHTML]="t.getStatus().html"></div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="{{ type }}"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
        <div class="col-auto">
          <span class="data-info"
            >Found: {{ pageInfo.totalRecord }}
            {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
